export type TruncatedDisplayText = {
  full: string;
  display: string;
  truncated: boolean;
};

export function truncateDisplayTextWords(text: string, maxWords = 4): TruncatedDisplayText {
  const full = String(text ?? "").trim();
  if (!full) return { full, display: full, truncated: false };
  const words = full.split(/\s+/).filter(Boolean);
  if (words.length <= maxWords) {
    return { full, display: full, truncated: false };
  }
  return {
    full,
    display: `${words.slice(0, maxWords).join(" ")}...`,
    truncated: true,
  };
}
